export enum RelationshipActions {
  ASSIGN_ROLE = 'assign_role',
  ASSIGN_TENANT = 'assign_tenant',
  ASSIGN_PERMISSIONS = 'assign_permissions',
  ASSIGN_SUBSCRIPTION = 'assign_subscription',
  ASSIGN_WORKSPACE = 'assign_workspace',
}
